import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgConfusedSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M32.04 18.2c-.41 0-.75-.34-.75-.75v-2.74c0-.41.34-.75.75-.75h1.85c2.12 0 3.2-.71 3.2-2.11 0-1.38-2.03-2.31-5.05-2.31-2.52 0-5.07.84-5.07 2.72 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-2.56 2.58-4.22 6.57-4.22 3.98 0 6.55 1.5 6.55 3.81 0 2.26-1.76 3.61-4.7 3.61h-1.1v2c0 .41-.34.74-.75.74ZM32.03 24.03c-1.24 0-2.24-1.01-2.24-2.24a2.25 2.25 0 0 1 2.24-2.24 2.25 2.25 0 0 1 2.24 2.24c0 1.23-1 2.24-2.24 2.24Zm0-2.98c-.41 0-.74.33-.74.74s.33.74.74.74.74-.33.74-.74-.33-.74-.74-.74Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M37.59 15.52c-.95.59-2.19.94-3.7.94h-.1v1c0 .53-.24.99-.61 1.32a3.24 3.24 0 0 1 2.09 3.02c0 1.79-1.46 3.24-3.24 3.24-1.79 0-3.24-1.46-3.24-3.24 0-1.39.88-2.56 2.11-3.03-.37-.32-.6-.79-.6-1.31v-2.75c0-.96.79-1.75 1.75-1.75h1.85c.72 0 1.18-.09 1.51-.21-.82-.83-1.74-1.56-2.72-2.19-.21-.01-.41-.02-.64-.02-1.97 0-4.07.6-4.07 1.72 0 .96-.79 1.75-1.75 1.75s-1.75-.79-1.75-1.75c0-1.7.86-3.07 2.37-3.99-.93-.17-1.86-.27-2.82-.27C15.19 8 8 15.19 8 24.03s7.19 16.03 16.03 16.03 16.03-7.19 16.03-16.03c0-3.13-.92-6.04-2.47-8.51Zm-8.07 16.31c-.09.33-.39.56-.72.56-.06 0-.13-.01-.19-.03l-9.53-2.55a.75.75 0 1 1 .39-1.45L29 30.91c.39.1.63.52.52.92Z",
    fill: "currentColor"
  }));
}

export { SvgConfusedSelectedEmojiSecondary as default };
